mutation SetYouTubeSpeedSettings(
  $defaultLevel: String!
  $brakeEnabled: Boolean!
  $dailyBudgetUnits: Int
  $demoHoldbackSlots: Int!
  $appChatLimit: Int
  $accountChatLimit: Int
  $expectedUpdatedAt: AWSDateTime
) {
  panel: StreamToolsSetYouTubeSpeedSettings(
    defaultLevel: $defaultLevel
    brakeEnabled: $brakeEnabled
    dailyBudgetUnits: $dailyBudgetUnits
    demoHoldbackSlots: $demoHoldbackSlots
    appChatLimit: $appChatLimit
    accountChatLimit: $accountChatLimit
    expectedUpdatedAt: $expectedUpdatedAt
  ) {
    defaultLevel
    liveAllowed
    brakeEnabled
    dailyBudgetUnits
    dailyBudgetSaved
    demoHoldbackSlots
    appChatLimit
    appChatLimitSaved
    appChatLimitMax
    accountChatLimit
    accountChatLimitSaved
    updatedByEmail
    updatedAt
    pacificDay
    unitsToday
    resetsAt
    brakeCapLevel
    brakeCapSince
    quotaExhaustedAt
    slotsInUse
    sessions {
      sessionId
      accountId
      accountEmail
      startedByEmail
      channelId
      channelTitle
      scope
      eventId
      eventName
      startedAt
      lastReadAt
      unitsUsed
      level
      hot
      stale
      demoExempt
      foreignEvent
      countsTowardAppLimit
      countsTowardAccountLimit
    }
  }
}
